import { Button } from '@/lib';
import { useCompanyValues } from '@/providers';
import { useAuth0 } from '@auth0/auth0-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_SIDEBAR_LOGOS } from '../layout/Sidebars/ExternalSidebar/constants';
import { DefaultSidebarLogo } from '../layout/Sidebars/sidebar';

export const ExternalLanding: FC = () => {
  const { company } = useCompanyValues();
  const { t } = useTranslation('ALL');

  const { loginWithRedirect } = useAuth0();

  const onLoginButtonClicked = () => {
    loginWithRedirect();
  };

  return (
    <div className='flex h-screen w-screen flex-wrap content-center bg-yellow-500'>
      <div className='mx-auto flex max-w-2xl flex-col items-center gap-40 px-4 py-16 text-center text-brand-700 sm:px-6 sm:py-20 lg:px-8'>
        <header className='flex flex-col gap-1'>
          <div className='flex flex-col items-center gap-8'>
            {EXTERNAL_SIDEBAR_LOGOS[company]}
            <h3 className='text-sm text-yellow-700'>{t('poweredBy')}</h3>
          </div>
          <DefaultSidebarLogo />
        </header>
        <footer className='flex flex-col justify-between gap-12'>
          <h2 className='grid gap-1'>
            <p className='text-xl'>{t('welcomeToYour')}</p>
            <p className='text-3xl font-semibold'>{t('marketingDataPlatform')}</p>
          </h2>
          <a href='#' onClick={onLoginButtonClicked} className='w-full'>
            <Button text={t('signIn')} size='lg' className='w-full' />
          </a>
        </footer>
      </div>
    </div>
  );
};
